export enum FiltersEnum {
  search = 'search',
  archive = 'archive',
  archived = 'archived',
  subscription = 'subscription',
  projects = 'projects',
  sort = 'sort',
}
